export class PaymentHistoryRequest {
  public fechaDesde?: string;
  public fechaHasta?: string;
  public estadosPago: Array<string>;
  public elements: number;
  public page: number;
  public filter: string;
  public idsSucursales: Array<number>;
  public idsCashier: Array<number>;
  public idsPaymentMethods: Array<number>;
  public conceptoTipoExclude: Array<string>;
  public horaDesde?: string;
  public horaHasta?: string;
  public idUsuario?: any;
  public uuid?: any;
  constructor() {
    this.fechaDesde = null;
    this.fechaHasta = null;
    this.filter = null;
    this.estadosPago = new Array<string>();
    this.idsSucursales = null;
    this.idsCashier = null;
    this.idsPaymentMethods = null;
    this.conceptoTipoExclude = ['I', 'C', 'V'];
    this.horaDesde = null;
    this.horaHasta = null;
    this.idUsuario = null;
    this.uuid = null;
  }
}
